import { atomWithReset } from 'jotai/utils';

export type UnstakePledgeReviewAtomType = {
	chzAmount: string;
	ftName: string;
	teamFlagUrl: string;
	teamId: string;
	teamName: string;
};

export type ClaimPledgeReviewAtomType = {
	chzAmount: string;
	claimablePledgeItems: Array<{
		ftName: string;
		teamId: string;
	}>;
};

export const UnstakePledgeReviewAtom = atomWithReset<UnstakePledgeReviewAtomType>({
	chzAmount: '',
	ftName: '',
	teamFlagUrl: '',
	teamId: '',
	teamName: ''
});

export const ClaimPledgeReviewAtom = atomWithReset<ClaimPledgeReviewAtomType>({
	chzAmount: '',
	claimablePledgeItems: []
});
